import {
  updateCountries,
  updateDateOperator,
  updateDirectReportsFilter,
  updateEmployeeJobLevel,
  updateHireEndDate,
  updateHireStartDate,
  updateLeaderLevel,
  updateLeaderLogins,
  updateManagerFilter,
  updateMetricFilter,
  updateMetricName,
  updateMetricOperator,
  updateMetricValue,
} from '../actions/ruleFiltersActions';

export const SegmentType = {
  BUILD: 'build',
  IMPORT: 'import',
  EXISTING: 'existing',
};

export const UploadType = {
  S3: 's3',
  FILE: 'file',
  FIELD: 'field',
};

export const MessageType = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'informational',
  ERROR: 'error',
  BIAS: 'bias',
};

export const S3URLPattern = new RegExp(/s3?:/);

export const EmailPattern = new RegExp(
  /^"([a-zA-Z0-9]+[,\s\-]{0,}[a-zA-Z0-9]+){1,}"<([^._%+-,][a-zA-Z0-9._%+-]+[^._%+\-,$]@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})>$/,
);

export const FileUploadStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const MAX_ALLOWED_FILE_SIZE = 3 * 1024 * 1024;

export const IS_FIRST_VISIT = 'isFirstVisit';

export const CREATED_SEGMENT_FILTER_OPTION = ['Segment Name'];

export const LEADER_LEVEL_INFO =
  'Leader level is the level of the leader in the org chart. You can get the leader level from the phonetool by counting the level top to bottom in the hierarchy';

export const LEADER_NAME_INFO =
  'Name of the leader. All the reportees under a leader will be fetched.';

export const COUNTRY_INFO =
  'Select countries to fetch your target audience. You can choose multiple countries from the dropdown';

export const MANAGER_INFO = 'Filter to target audience based on their role as a manager or an IC.';
export const JOB_LEVEL_INFO =
  'Specify job level of an employee. You can choose multiple job levels from here';
export const HIRE_DATE_INFO =
  'Specify the hire date filter. You can select different range from the dropdown';

export const DEFAULT_NOTIFICATION_TIMEOUT_MS = 3000;
export const DELETE_SEGEMENT_MESSAGE = 'Segment deleted successfully.';
export const DELETE_SEGMENT_FAILED = 'Failed to delete the segment. Please try again in sometime.';

export const SegmentFilters = {
  LEADER_FILTER: 'leaderFilter',
  COUNTRY_FILTER: 'countryFilter',
  EMPLOYEE_JOB_LEVEL_FILTER: 'employeeJobLevel',
  MANAGER_STATUS_FILTER: 'managerStatusFilter',
  HIRE_DATE_FILTER: 'hireDateFilter',
  METRIC_FILTER: 'metricFilter',
};

export const RuleFilterConfig = {
  [SegmentFilters.LEADER_FILTER]: Array.of('leaderJobLevel', 'leaderLogins'),
  [SegmentFilters.COUNTRY_FILTER]: Array.of('countries'),
  [SegmentFilters.EMPLOYEE_JOB_LEVEL_FILTER]: Array.of('employeeJobLevels'),
  [SegmentFilters.MANAGER_STATUS_FILTER]: Array.of('isManager'),
  [SegmentFilters.HIRE_DATE_FILTER]: Array.of(
    'dateOperator',
    'lastHireEndDateInMillis',
    'lastHireDateInMillis',
  ),
};

export const RuleFilterActionConfig = {
  countries: updateCountries,
  dateOperator: updateDateOperator,
  lastHireDateInMillis: updateHireStartDate,
  lastHireEndDateInMillis: updateHireEndDate,
  leaderJobLevel: updateLeaderLevel,
  leaderLogins: updateLeaderLogins,
  metricName: updateMetricName,
  metricOperator: updateMetricOperator,
  metricValue: updateMetricValue,
  employeeJobLevels: updateEmployeeJobLevel,
  targetEmployeeJobLevels: updateEmployeeJobLevel,
  isManager: updateManagerFilter,
  isDirectReport: updateDirectReportsFilter,
  metrics: updateMetricFilter,
};

export const RuleFilterDateFields = ['lastHireEndDateInMillis', 'lastHireDateInMillis'];

export const RuleFilterMetricMapping = {
  total_job_level_dwell_time: 'Tenure at level (months)',
  job_tech_indicator: 'Job Tech Indicator',
  employee_gender: 'Gender',
  job_family_name: 'Job family',
  current_tenure_years: 'Total Tenure (years)'
};

export const ManagerOption = {
  IS_MANAGER: 'Is a manager at Amazon',
  NOT_MANAGER: 'Not a manager at amazon',
};

export const DEFAULT_STATE = {
  emailTo: '',
  emailFrom: '',
  emailSubject: '',
  errorOnSave: false,
  isLoading: false,
  isFormSaved: false,
  selectedTab: 'Content',
  expanderStates: {
    isEmailToExpanded: false,
    isEmailFromExpanded: false,
    isEmailSubjectExpanded: false,
  },
  inputValidations: {
    isEmailSubjectValid: false,
    isContentValid: false,
    isValidationTriggered: false,
    isFormValid: false,
  },
  saveAndContinueButton: {
    isOpen: false,
  },
  saveAsTemplateButton: {
    isOpen: false,
    isError: false,
    templateName: '',
    templateNameExists: false,
  },
  templatesButton: {
    isOpen: false,
    selectedTemplateName: '',
    isLoading: true,
    isErrorLoadingTemplate: false,
    selectedTemplateSubject: '',
    selectedTemplateHtml: '',
  },
};
